const URL_BASE = "https://d4.invalid";
const HOME_PATH = "/";
const LOGIN_PATH = "/login";
const COOKIE_CUSTOMER_SESSION_INVALIDATED_NAME = "d4customerSessionInvalidated";

const PUBLIC_PATHS = [
  "/create-new-password",
  "/forgottenPassword",
  "/register",
  "/booked",
  "/iframe",
  "/lowCostSearch",
  "/redirectToBooked",
];

function parseUrl(url) {
  return new URL(url || HOME_PATH, URL_BASE);
}

function parseInternalUrl(url) {
  const parsedUrl = parseUrl(url);

  return parsedUrl.origin === URL_BASE
    ? parsedUrl
    : new URL(HOME_PATH, URL_BASE);
}

function isPath(pathname, route) {
  return pathname === route || pathname.startsWith(`${route}/`);
}

function isPublicMandatoryLoginRoute(url) {
  const parsedUrl = parseUrl(url);

  if (PUBLIC_PATHS.some((route) => isPath(parsedUrl.pathname, route))) {
    return true;
  }

  return (
    isPath(parsedUrl.pathname, LOGIN_PATH) &&
    (parsedUrl.searchParams.get("isLoginRequired") === "true" ||
      parsedUrl.searchParams.has("saml"))
  );
}

function hasAuthenticatedCustomerSession({
  customerToken,
  customerName,
  customerDevice,
}) {
  return Boolean(customerToken && customerName && customerDevice);
}

function createMandatoryLoginUrl(redirectAfterLogin, language) {
  const parsedRedirect = parseInternalUrl(redirectAfterLogin);
  const internalRedirect = `${parsedRedirect.pathname}${parsedRedirect.search}${parsedRedirect.hash}`;
  const query = new URLSearchParams({ isLoginRequired: "true" });

  if (!isPath(parsedRedirect.pathname, LOGIN_PATH)) {
    query.set("redirectAfterLogin", internalRedirect);
  }

  const resolvedLanguage = Array.isArray(language) ? language[0] : language;
  if (resolvedLanguage) {
    query.set("lang", resolvedLanguage);
  }

  return `${LOGIN_PATH}?${query.toString()}`;
}

module.exports = {
  COOKIE_CUSTOMER_SESSION_INVALIDATED_NAME,
  createMandatoryLoginUrl,
  hasAuthenticatedCustomerSession,
  isPublicMandatoryLoginRoute,
};
